/**
 * @file: YsAccount.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 萤石云账户管理
 */
import request from '@/utils/request'

/**
 * 获取萤石云账号accessToken
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function ysAccessTokenGet(data) {
  return request({
    type: 'device',
    url: 'ys/access/token/get',
    method: 'post',
    data
  })
}

/**
 * 添加萤石云账户
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function ysAccountAdd(data) {
  return request({
    type: 'device',
    url: 'ys/account/add',
    method: 'post',
    data
  })
}

/**
 * 删除萤石云账户
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function ysAccountDelete(data) {
  return request({
    type: 'device',
    url: 'ys/account/delete',
    method: 'post',
    data
  })
}

/**
 * 获取萤石云账户详情
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function ysAccountDetail(data) {
  return request({
    type: 'device',
    url: 'ys/account/detail',
    method: 'post',
    data
  })
}

/**
 * 编辑萤石云账户
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function ysAccountEdit(data) {
  return request({
    type: 'device',
    url: 'ys/account/edit',
    method: 'post',
    data
  })
}

/**
 * 获取萤石云账户分页列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function ysAccountPageList(data) {
  return request({
    type: 'device',
    url: 'ys/account/page/list',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/YsAccount.js